import type { AnyRoute } from '@tanstack/react-router';
import {
  createRoute,
  lazyRouteComponent,
  redirect
} from '@tanstack/react-router';
import { verifySession } from '#domains/auth';

export const createSettingsRoutes = <TParent extends AnyRoute>(
  parent: TParent
) => {
  const parentRoute = createRoute({
    path: '/settings',
    getParentRoute: () => parent
  });

  const settingsIndexRoute = createRoute({
    path: '/', // This matches /settings
    getParentRoute: () => parentRoute,
    // This loader/beforeLoad ONLY runs for /settings, not /settings/account
    loader: () => {
      throw redirect({
        to: '/settings/account',
        replace: true
      });
    }
  });

  const accountSettingstRoute = createRoute({
    path: '/account',
    getParentRoute: () => parentRoute,
    component: lazyRouteComponent(() => import('./pages/AccountPage')),
    loader: async () => {
      const result = await verifySession();

      if (!result?.data) {
        throw redirect({ to: '/', replace: true });
      }

      return result;
    }
  });

  const accountPasswordSettingstRoute = createRoute({
    path: '/account/password',
    getParentRoute: () => parentRoute,
    component: lazyRouteComponent(() => import('./pages/AccountPasswordPage'))
  });

  const generalSettingstRoute = createRoute({
    path: '/general',
    getParentRoute: () => parentRoute,
    component: lazyRouteComponent(() => import('./pages/GeneralPage'))
  });

  const sidebarSettingstRoute = createRoute({
    path: '/sidebar',
    getParentRoute: () => parentRoute,
    component: lazyRouteComponent(() => import('./pages/SidebarPage'))
  });

  const settingsRouteWithChildren = parentRoute.addChildren([
    settingsIndexRoute,
    accountSettingstRoute,
    accountPasswordSettingstRoute,
    generalSettingstRoute,
    sidebarSettingstRoute
  ]);

  return [settingsRouteWithChildren];
};
